<div style="padding:20px;">
    <mat-dialog-content>
    <h1>How can we help?</h1>
    <mat-form-field togglePosition="before" appearance="standard" style="width:100%;">
        <mat-label>Enter a Keyword</mat-label>
        <mat-icon matPrefix class="zmdi zmdi-search"></mat-icon>
        <input (input)="searchChange($event.target.value)" matInput style="width:100%;" type="search" placeholder="Deposit, Withdraw, PayPal, Scoring, Bonus Funds, etc."/>
    </mat-form-field>
    <mat-expansion-panel *ngFor="let category of categories;let cIndex = index;" [(expanded)]="expandCategories[cIndex]">
        <mat-expansion-panel-header>
            <mat-panel-title style="font-size:24px;">
                {{category.toUpperCase()}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-expansion-panel *ngFor="let title of titles | FilterTitles:category; let i = index;trackBy: titlesTracker" (opened)="loadAnswer(i,category)">
            <mat-expansion-panel-header>
                <mat-panel-title style="font-weight:bold;">
                    {{title.title}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div style="padding:20px;">
                <p *ngIf="title.data != null">{{title.data}}</p>
                <mat-spinner *ngIf="title.data == null" style="margin:0px auto;" diameter="50"></mat-spinner>
            </div>
        </mat-expansion-panel>
    </mat-expansion-panel>
    <div style="text-align:center;">
        <h1>Still need assistance?</h1>
        <button mat-raised-button class="supportBtn" (click)="messageSupport()">
            <mat-icon matPrefix class="zmdi zmdi-email" style="padding-top:4px;"></mat-icon>
            Contact Support
        </button>
    </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
</div>